/**
 * Validates the form fields and enables/disables the submit button based on the form's validity.
 *
 * @param {HTMLFormElement} form - The memory form element.
 * @param {Boolean} photoExists
 */
function validateFields(form, photoExists) {
  if (!form) return;

  const contentInput = form.querySelector("textarea");
  const hiddenInput = form.querySelector("#tribute_memory_hidden");
  const inputs = form.querySelectorAll("input, select");

  setTimeout(() => {
    let isAttachmentFilled = Array.from(form.querySelectorAll("input[type='file']")).some(
      (input) => input.files.length > 0
    );
    let isContentFilled = contentInput?.value.trim() !== "";

    inputs.forEach((input) => {
      if (input.validity.patternMismatch) {
        input.setCustomValidity(
          "Please use normal characters (letters, apostrophe's and hyphens only)."
        );
      } else if (input.value.length > 100) {
        input.setCustomValidity("This field cannot exceed 100 characters.");
      }
    });

    if (hiddenInput) {
      hiddenInput.value = !photoExists && !isAttachmentFilled && !isContentFilled;
    }

    _toggleSubmitButton(form);
  }, 100);
}

/**
 * Makes sure the file input field is not included in the form submission when it is not visible.
 *
 * @param {HTMLElement} fileInputField - The container element of the file input field.
 */
function toggleFileInputVisibility(fileInputField) {
  const fileInput = fileInputField.querySelector("input[type='file']");
  const hiddenInput = fileInputField.querySelector("input[type='hidden']");
  if (fileInputField.classList.contains("hidden")) {
    fileInput.removeAttribute("name");
    if (hiddenInput) {
      hiddenInput.remove();
    }
  }
}

/**
 * Toggles the submit button based on the validity of the form.
 *
 * @param {HTMLFormElement} form - The memory form element.
 */
function _toggleSubmitButton(form) {
  const submitButton = form.querySelector("button[type='submit']");
  submitButton.disabled = !form.checkValidity();
}

/**
 * Retrieves the next memory ID from the URL query parameters.
 * This ID is used to determine the next item in a sequence of memories, retrieved from local storage.
 *
 * @returns {string|boolean} - The next memory ID, or false if none exists.
 */
function getNextMemoryId() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const selectedMemory = urlParams.get("selectedMemory");
    const selectedMemories = JSON.parse(localStorage.getItem("selectedMemories")) || [];
    return selectedMemories[selectedMemories.indexOf(selectedMemory) + 1] || false;
  } catch {
    return false;
  }
}

export { toggleFileInputVisibility, getNextMemoryId, validateFields };
